import { Subscription, interval } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Deployment } from 'src/app/core/models/deployment';
import { DeploymentService } from '../../../../core/services/deployment.service';
import { NavigationService } from '../../../../core/services/navigation.service';
import { MatDialog } from '@angular/material/dialog';
import { CloudProvider } from '../../../../core/models/cloudProvider';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DeleteDeploymentComponent } from '../../modals/delete-deployment/delete-deployment.component';
import { StorageService } from 'src/app/core/services/storage.service';
import { AddDeploymentComponent } from '../../modals/add-deployment/add-deployment.component';
import { HeaderService } from 'src/app/core/services/header.service';
import { JobOutputDialogComponent } from 'src/app/modules/job/modals/jobActions/job-output-dialog/job-output-dialog.component';
import { SyncConfigService } from 'src/app/core/services/sync-config.service';
import { Entities } from 'src/app/core/models/globals';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { ConfigEntityService } from '../../../../core/services/config-entity.service';
import { Component, OnInit, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-deployment-list',
  templateUrl: './deployment-list.component.html',
  styleUrls: ['./deployment-list.component.scss'],
})
export class DeploymentListComponent implements OnInit, OnDestroy {
  clickedDepName: string = '';
  dataReloadSubscription: Subscription;
  universalSub: Subscription;
  deployments: Deployment[];
  dataEmpty: boolean = false;
  cloudProviders: CloudProvider[];
  currentEntity: string;
  userDepCheck: Subscription;
  isPathConfigurator: boolean = false;
  sortName = 0;
  sortLocation = 0;
  sortScheduler = 0;
  sortInfrastructure = 0;
  sortStatus = 0;
  // sortLicenseState = 0;
  p: number = 1;
  isUserGlobalAdmin: boolean = this.authenticationService.isUserGlobalAdmin;
  constructor(
    private spiner: NgxSpinnerService,
    private router: Router,
    public depService: DeploymentService,
    private route: ActivatedRoute,
    private navService: NavigationService,
    public dialog: MatDialog,
    private snackbar: MatSnackBar, private storageService: StorageService,
    private headerService: HeaderService,
    private syncConfig: SyncConfigService, private authenticationService: AuthenticationService,
    private configEntityService: ConfigEntityService,
  ) { }

  async ngOnInit() {
    this.spiner.show();
    this.universalSub = this.navService.breadcrumbEntity.subscribe(x => {
      if (this.currentEntity != x) {
        this.currentEntity = x;
      }
    })
    if (this.currentEntity != Entities.Configurator) {
      this.isPathConfigurator = true;
      this.navService.subNavData(Entities.Deployments);
    }
    if (this.currentEntity == Entities.Configurator) {
      //this.navService.sendLeftPanelIndex();
      this.configEntityService.sendActiveEntity('Deployment')
      this.navService.sendChildData('Deployment')
      this.navService.sendParentData('')
    }
    this.deployments = this.depService.getProfileInfoesFromSubject();
    if (this.deployments) { this.spiner.hide() }
    await this.loadDepList()
    this.dataReloadSubscription = interval(this.syncConfig.config.deployments.listReqInterval).subscribe(async (x) => {
      await this.loadDepList()
    });
  }

  async loadDepList() {
    this.universalSub = await this.depService
      .getAllDeploymentsForUser()
      .subscribe({
        next: (data) => {
          if (data == null) {
            this.spiner.hide()
            this.dataEmpty = true;
          } else {
            this.deployments = <Deployment[]>JSON.parse(JSON.stringify(data));
            this.headerService.updateDeploymentList(this.deployments);
            this.depService.emptyUserAccess();
            this.depService.checkUserDepAccess();
            if (this.deployments.length == 0) {
              this.dataEmpty = true;
              this.spiner.hide();
              return;
            }
            this.dataEmpty = false;
            this.spiner.hide();
          }
        }, error: (err) => {
          this.spiner.hide()
          this.dataEmpty = true;
        }
      }
      );
  }

  ngOnDestroy() {
    if (this.dataReloadSubscription) {
      this.dataReloadSubscription.unsubscribe();
    }
    if (this.universalSub) {
      this.universalSub.unsubscribe()
    }
    if (this.snackbar) {
      this.snackbar.dismiss();
    }
    if (this.userDepCheck) this.userDepCheck.unsubscribe();
  }

  redirectTo(deployment: Deployment) {
    this.clickedDepName = deployment.name;
    if (this.currentEntity == 'Configurator') {
      this.router.navigate([deployment.cloud, this.clickedDepName, 'settings'], { relativeTo: this.route });
      this.navService.sendParentData(this.clickedDepName)
    } else {
      this.router.navigate([deployment.cloud, this.clickedDepName], { relativeTo: this.route });
      this.navService.sendChildData(this.clickedDepName);
      this.storageService.sendActiveStorageName(deployment.storageAccountName)
    }
  }

  addDeployment(providerValue: number, providerName: string) {
    const dialogRef = this.dialog.open(AddDeploymentComponent, {
      width: '60%',
      autoFocus: true,
      disableClose: true,
      data: { cloudValue: providerValue, cloudName: providerName }
    })
    dialogRef.afterClosed().subscribe(async res => {
      if (res) {
        this.snackbar.open('Deployment Created Successfully, Wait For Some Time To be Active or Refresh Page.', 'Ok',
          {
            duration: 3000
          })
        await this.loadDepList();
      }
    })
  }

  // checkDepStatus(deploymentName: string, depId: string) {
  //   this.dialog.open(JobOutputDialogComponent, {
  //     width: '90%',
  //     autoFocus: false,
  //     disableClose: true,
  //     hasBackdrop: false,
  //     id: "jobOutputDialogJobs",
  //     data: { depName: deploymentName, depId: depId, path: "", id: "jobOutputDialogJobs" },
  //     panelClass: 'custom-output-dialog-container'
  //   });
  // }

  // deleteDeployment(depName: string) {
  //   const dialogRef = this.dialog.open(DeleteDeploymentComponent, {
  //     width: '30%',
  //     autoFocus: true,
  //     disableClose: true,
  //     data: { name: depName, type: 'deployment'},
  //   })
  //   dialogRef.afterClosed().subscribe(async res => {
  //     if (res) {
  //       this.depService.deleteDeployment(depName, res?.returnObject?.skipCloud).subscribe({
  //         next: (data) => {
  //           this.spiner.show();
  //           this.snackbar.open('Deployment Deleted Successfully, Wait For Some Time or Refresh Page Once.', 'Ok',
  //             {
  //               duration: 3000
  //             })
  //           this.loadDepList();
  //           this.locationReload()
  //         },
  //         error: (error) => {
  //           this.snackbar.open(error?.error?.message ||'Failed to delete deployment.', 'Ok', { duration: 3000 })
  //         }
  //       });
  //     }
  //   })
  // }

  // sortByLicenseState() {
  //   if (this.sortLicenseState == 0) {
  //     this.deployments.sort((a, b) => 0 - (a.licenseConnectivity.toLowerCase() > b.licenseConnectivity.toLowerCase() ? 1 : -1));
  //   }
  //   if (this.sortLicenseState == 1) {
  //     this.deployments.sort((a, b) => 0 - (b.licenseConnectivity.toLowerCase() > a.licenseConnectivity.toLowerCase() ? 1 : -1));
  //   }
  //   this.sortLicenseState++
  //   if (this.sortLicenseState == 2) {
  //     this.sortLicenseState = 0;
  //   }
  // }
  
  sortByName() {
    if (this.sortName == 0) {
      this.deployments.sort((a, b) => 0 - (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1));
    }
    if (this.sortName == 1) {
      this.deployments.sort((a, b) => 0 - (b.name.toLowerCase() > a.name.toLowerCase() ? 1 : -1));
    }
    this.sortName++
    if (this.sortName == 2) {
      this.sortName = 0;
    }
  }

  sortByLocation() {
    if (this.sortLocation == 0) {
      this.deployments.sort((a, b) => 0 - (a.location.toLowerCase() > b.location.toLowerCase() ? 1 : -1));
    }
    if (this.sortLocation == 1) {
      this.deployments.sort((a, b) => 0 - (b.location.toLowerCase() > a.location.toLowerCase() ? 1 : -1));
    }
    this.sortLocation++
    if (this.sortLocation == 2) {
      this.sortLocation = 0;
    }
  }

  sortByScheduler() {
    if (this.sortScheduler == 0) {
      this.deployments.sort((a, b) => 0 - (a.scheduler.toLowerCase() > b.scheduler.toLowerCase() ? 1 : -1));
    }
    if (this.sortScheduler == 1) {
      this.deployments.sort((a, b) => 0 - (b.scheduler.toLowerCase() > a.scheduler.toLowerCase() ? 1 : -1));
    }
    this.sortScheduler++
    if (this.sortScheduler == 2) {
      this.sortScheduler = 0;
    }
  }

  sortByInfrastructure() {
    if (this.sortInfrastructure == 0) {
      this.deployments.sort((a, b) => 0 - (a.cloud.toLowerCase() > b.cloud.toLowerCase() ? 1 : -1));
    }
    if (this.sortInfrastructure == 1) {
      this.deployments.sort((a, b) => 0 - (b.cloud.toLowerCase() > a.cloud.toLowerCase() ? 1 : -1));
    }
    this.sortInfrastructure++
    if (this.sortInfrastructure == 2) {
      this.sortInfrastructure = 0;
    }
  }

  sortByStatus() {
    if (this.sortStatus == 0) {
      this.deployments.sort((a, b) => 0 - (a.status.toLowerCase() > b.status.toLowerCase() ? 1 : -1));
    }
    if (this.sortStatus == 1) {
      this.deployments.sort((a, b) => 0 - (b.status.toLowerCase() > a.status.toLowerCase() ? 1 : -1));
    }
    this.sortStatus++
    if (this.sortStatus == 2) {
      this.sortStatus = 0;
    }
  }

  refreshComponent() {
    let url = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([decodeURI(url)]);
    });
  }

  locationReload() {
    location.reload();
  }
}
